import { ApiHelper, ApiHelperWithData, ApiResponseWithData, BaseRequest, splitParams } from '..';

/**
 *  CL AI ChatGPT
 */
export class CloverAiChatApi {
  private withData: ApiHelperWithData;
  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  aiChat = (
    params: { message: string } & BaseRequest,
  ): Promise<ApiResponseWithData<{ msg: string }>> => {
    const url = '/p/chat';
    return this.withData.post(url, ...splitParams(params));
  };
}
